import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import PostPage from "./pages/PostPage";
import CategoryPage from "./pages/CategoryPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AdminPage from "./pages/AdminPage";
import "./App.css";

function NotFound() {
  return (
    <div className="container" style={{ padding: "80px 0", textAlign: "center", color: "#9ca3af" }}>
      <h2>404 — Page not found</h2>
    </div>
  );
}

export default function App() {
  const base = import.meta.env.BASE_URL.replace(/\/$/, "");

  return (
    <AuthProvider>
      <BrowserRouter basename={base}>
        <Routes>
          {/* Admin has its own full-page layout (no header/footer) */}
          <Route path="/admin" element={<AdminPage />} />

          {/* All other pages share the public layout */}
          <Route
            path="*"
            element={
              <>
                <Header />
                <main className="site-main">
                  <Routes>
                    <Route path="/"                element={<HomePage />} />
                    <Route path="/post/:id"        element={<PostPage />} />
                    <Route path="/category/:name"  element={<CategoryPage />} />
                    <Route path="/login"           element={<LoginPage />} />
                    <Route path="/register"        element={<RegisterPage />} />
                    <Route path="*"               element={<NotFound />} />
                  </Routes>
                </main>
                <Footer />
              </>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
